/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_MapInputs */

const en_nav_map = /** @type {(inputs: Nav_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The map`)
};

/**
* | output |
* | --- |
* | "The map" |
*
* @param {Nav_MapInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_map = /** @type {((inputs?: Nav_MapInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_MapInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_map(inputs)
});